import { packingSlipSchema } from "@redotech/redo-fulfillment-operations-common/packing-slips/packing-slip-definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getPackingSlipTemplatesByTeam = {
  name: "getPackingSlipTemplatesByTeam" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.array(packingSlipSchema),
};
